import React from 'react'
import {
  Box,
  Container as ContainerMUI,
  Stack,
  Typography,
} from '@mui/material'
import airLogo from 'assets/images/logo-air.png'

const Container = ({ children }) => {
  return (
    <>
      <ContainerMUI>
        <Stack flexDirection="row" justifyContent="center" m={2}>
          {children}
        </Stack>
        <Stack flexDirection="row" justifyContent="center" mt={6}>
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ pb: 5, fontStyle: 'italic' }}
            mt="3px"
            mr={1}
          >
            <strong>Powered by</strong>
          </Typography>
          <Box component="img" src={airLogo} sx={{ height: 20 }} />
        </Stack>
      </ContainerMUI>
    </>
  )
}

export default Container
